import DashboardActionTypes from './DashboardActionTypes'

export interface ResetLastAffectedOrder {
  type: DashboardActionTypes.RESET_LAST_AFFECTED_ORDER;
}

export function resetLastAffectedOrder(): ResetLastAffectedOrder {

  return {
    type: DashboardActionTypes.RESET_LAST_AFFECTED_ORDER,
  }
}
